import { Alert, Typography } from '@mui/material';
import { TextInput, useRecordContext } from 'react-admin';

/**
 * Search engine metadata.
 *
 * Written into the storefront's existing `meta` table, keyed by the page's
 * address - the same table it already consults for every page it serves. So
 * these fields take effect immediately, with no change to the site.
 *
 * Left empty, a page falls back to the shop's site-wide title and description
 * rather than rendering blank ones, which is why an entirely empty set of
 * fields deletes the row instead of storing four NULLs.
 */
export function SeoFields({ uri, showNotice = true }: { uri?: string; showNotice?: boolean }) {
  const record = useRecordContext();

  return (
    <>
      {showNotice && (
        <>
          <Typography variant="overline" color="text.secondary" sx={{ mt: 2 }}>
            SEO
          </Typography>
          <Alert severity="info" variant="outlined" sx={{ mb: 2, width: '100%' }}>
            {uri != null && record != null ? (
              <>Platí pre adresu <strong>/{uri}</strong>. </>
            ) : null}
            Ak necháte polia prázdne, použije sa všeobecný názov a popis e-shopu.
          </Alert>
        </>
      )}
      <TextInput
        source="seo.title"
        label="SEO názov"
        fullWidth
        helperText="Text v záložke prehliadača a nadpis vo výsledkoch vyhľadávania. Najlepšie do 60 znakov."
      />
      <TextInput
        source="seo.description"
        label="SEO popis"
        multiline
        rows={2}
        fullWidth
        helperText="Popis pod nadpisom vo vyhľadávaní. Najlepšie do 155 znakov."
      />
      <TextInput source="seo.keywords" label="Kľúčové slová" fullWidth helperText="Oddelené čiarkami." />
      <TextInput
        source="seo.canonical"
        label="Kanonická adresa"
        fullWidth
        helperText="Vyplňte len vtedy, ak sa rovnaký obsah nachádza aj na inej adrese, ktorá má byť tou hlavnou."
      />
    </>
  );
}
